import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonItem } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = VideoLessonItem;

export const ListGetVideoLessonsSlice = createSlice({
  name: "ListGetVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    ListGetVideoLesson: (state, action) => {
      state.isLoading = true;
    },

    successListGetVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListGetVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  ListGetVideoLesson,
  successListGetVideoLessons,
  failureListGetVideoLessons,
} = ListGetVideoLessonsSlice.actions;

export default ListGetVideoLessonsSlice.reducer;
